import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'list': [],
  'loading': false,
  'pdf': null,
  'excel': null,
};

export const invoicesListDownload = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_INVOICES_DOWNLOAD_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_INVOICES_DOWNLOAD_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'pdf': action.response.pdf,
      'excel': action.response.excel,
    }),
    [ActionTypes.FETCHED_INVOICES_DOWNLOAD_LIST_FAILED]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.CLEAR_INVOICES_DOWNLOAD_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
